module.exports = __webpack_public_path__ + "08196ac07570e27778603419a961336b.png";